module.exports = __webpack_public_path__ + "static/img/TZ@3x.d54276a4.jpg";